export const RECURRENCE_MONTHS = {
  MONTHLY: 1,
  QUARTERLY: 3,
  YEARLY: 12,
};
